import React, { useEffect, useState, lazy, Suspense } from "react";
import { LoadingSpinner } from 'components/common';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRole } from "redux/authorization/roleSlice";
import RoleDetailHeader from "components/app/authorization/role/detail/RoleDetailHeader";
import { FaList, FaHistory } from "react-icons/fa";
import useBreadcrumb from "hooks/useBreadcrumb";

const RoleDetailInfo = lazy(() => import("components/app/authorization/role/detail/RoleDetailInfo"));
const RoleActivity   = lazy(() => import("components/app/authorization/role/detail/RoleActivity"));

const TabFallback = () => (
  <div className="tw-py-12">
    <LoadingSpinner size="md" />
  </div>
);

const TABS = [
  { key: "detail",   label: "Detail",            Icon: FaList    },
  { key: "activity", label: "Activities history", Icon: FaHistory },
];

const RoleDetailPage = () => {
  const params   = useParams();
  const dispatch = useDispatch();
  const { recordData: role } = useSelector((state) => state.authorization_role);

  // Breadcrumb: hiển thị tên role thay vì id
  useBreadcrumb(
    role
      ? [
          { label: 'Roles', to: '/authorization/roles' },
          { label: role.name || `Role ${params.id}` }
        ]
      : null
  );

  const [trigger,       setTrigger]       = useState(0);
  const [activeTab,     setActiveTab]     = useState("detail");
  const [recordLoading, setRecordLoading] = useState(true);

  useEffect(() => {
    setRecordLoading(true);
    dispatch(getRole(params.id)).finally(() => setRecordLoading(false));
  }, [params.id, trigger, dispatch]);

  return (
    <div>
      <RoleDetailHeader role={role} setTrigger={setTrigger} />

      {recordLoading ? (
        <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 tw-shadow-sm">
          <LoadingSpinner size="lg" message="Loading role details..." />
        </div>
      ) : (
        <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-gray-200 tw-shadow-sm tw-overflow-hidden">
          {/* Tab nav */}
          <div className="tw-border-b tw-border-gray-100 tw-bg-gray-50 tw-px-5 tw-py-3">
            <nav className="tw-flex tw-flex-nowrap tw-items-center tw-gap-1 tw-bg-gray-100 tw-rounded-lg tw-p-1 tw-w-max tw-max-w-full tw-overflow-x-auto tw-overscroll-x-contain tw-no-scrollbar">
              {TABS.map(({ key, label, Icon }) => (
                <button
                  key={key}
                  onClick={() => setActiveTab(key)}
                  className={`tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded tw-transition-all tw-duration-200 tw-outline-none tw-cursor-pointer tw-border-0 ${
                    activeTab === key
                      ? "tw-bg-white tw-text-blue-700 tw-shadow-sm tw-shadow-gray-200/80 tw-font-semibold"
                      : "tw-bg-transparent tw-text-gray-500 hover:tw-text-gray-700 hover:tw-bg-white/60"
                  }`}
                >
                  <Icon size={12} className={activeTab === key ? "tw-text-blue-600" : "tw-text-gray-400"} />
                  {label}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab content */}
          <div className="tw-bg-gray-50 tw-p-4">
            <Suspense fallback={<TabFallback />}>
              {activeTab === "detail"   && role && <RoleDetailInfo role={role} />}
              {activeTab === "activity" && <RoleActivity />}
            </Suspense>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleDetailPage;
